// tutorReducer.js
import {
    FETCH_TUTORS_REQUEST,
    FETCH_TUTORS_SUCCESS,
    FETCH_TUTORS_FAILURE,
    ADD_TUTOR_REQUEST,
    ADD_TUTOR_SUCCESS,
    ADD_TUTOR_FAILURE,
    UPDATE_TUTOR_REQUEST,
    UPDATE_TUTOR_SUCCESS,
    UPDATE_TUTOR_FAILURE,
    DELETE_TUTOR_REQUEST,
    DELETE_TUTOR_SUCCESS,
    DELETE_TUTOR_FAILURE,
  } from "./actionTypes";
  
  const initialState = {
    tutors: [],
    loading: false,
    error: null,
  };
  
  const tutorReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_TUTORS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
  
      case FETCH_TUTORS_SUCCESS:
        return {
          ...state,
          loading: false,
          tutors: action.payload,
        };
  
      case FETCH_TUTORS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case ADD_TUTOR_REQUEST:
      case UPDATE_TUTOR_REQUEST:
      case DELETE_TUTOR_REQUEST:
        return {
          ...state,
          loading: true,
        };
  
      case ADD_TUTOR_SUCCESS:
        return {
          ...state,
          loading: false,
          tutors: {
            ...state?.tutors,
            data: [action.payload?.data,...state.tutors.data],
          },
        };
  
      case ADD_TUTOR_FAILURE:
      case UPDATE_TUTOR_FAILURE:
      case DELETE_TUTOR_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case UPDATE_TUTOR_SUCCESS:
        return {
          ...state,
          loading: false,
          tutors: {
            ...state?.tutors,
            data: state.tutors.data?.map((item) =>{
              const result = item?.id == action.payload?.data?.id
                ? action.payload.data
                : item
                return result
            }
            ),
          },
        };
  
      case DELETE_TUTOR_SUCCESS:
        return {
          ...state,
          loading: false,
          tutors: {
            ...state?.tutors,
            data: state.tutors.data?.filter(
              (item) => item?.id !== action.payload?.data?._id
            ),
          },
        };
  
      default:
        return state;
    }
  };
  
  export default tutorReducer;
  